/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 24/10/2021.
 */

import React from 'react'

type Props = {
  error: any
}

//
// This is work in prigress - we need a way to handle specific errors for specific endpoints
//

export const ErrorView = ({ error }: Props) => {
  //  const logout = authStore((state) => state.logout)

  const message: string = error?.message ? error?.message : 'Something went wrong'
  const status: number = error?.status ? error?.status : 500

  return (
    <div className="container">
      <div className="row" style={{}}>
        <div className="col-6 mx-auto">
          <div className="mt-4 shadow bg-white py-5 rounded p-4">
            {message && status ? (
              <ErrorResult status={status} title={status} subTitle={error.message}></ErrorResult>
            ) : (
              <ErrorResult
                status="500"
                title="500"
                subTitle="This was not expected and could be caused by multiple things"
              ></ErrorResult>
            )}

            <div className="btn btn-primary w-100">
              <a className="text-decoration-none text-white" href="/">
                Back to the frontpage
              </a>
            </div>

            <div className="text-center text-decoration-none mt-4"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const ErrorResult = ({ status, title, subTitle }: any) => {
  return (
    <div className="my-0 py-3">
      <h4>{title}</h4>
      <p>{subTitle}</p>
    </div>
  )
}
